import { useTranslation } from '@shared/localization';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  triggerErrorToast,
  triggerInfoToast,
  triggerSuccessToast,
} from '@/libs/toasts';
import { PaymentIntentFlow } from '@/schemas/PaymentIntent';
import PaymentStore from '@/services/payments/PaymentStore';

import { isValidRedirectStatus } from './helpers/StatusHelper';
import { RedirectStatus } from './schemas/RedirectStatus';

export function StatusParamHandler() {
  const [searchParams, setSearchParams] = useSearchParams();

  const { t } = useTranslation();

  const toastMessageHandler = (status: RedirectStatus): void => {
    switch (status) {
      case RedirectStatus.Canceled:
        triggerInfoToast(t('Select a new payment method and proceed to pay.'));
        break;
      case RedirectStatus.Failure:
        triggerErrorToast(
          t(
            'Operation failed. Please try again with a different payment method.',
          ),
        );
        break;
      case RedirectStatus.Success:
        triggerSuccessToast(t('Operation completed with success!'));
        break;
    }
  };

  useEffect(() => {
    const paymentIntentId = searchParams.get('pid');
    const status = searchParams.get('status');

    const isStatusValid =
      PaymentStore.flow === PaymentIntentFlow.Manage
        ? status && isValidRedirectStatus(status)
        : paymentIntentId && status && isValidRedirectStatus(status);

    if (isStatusValid) {
      toastMessageHandler(status as RedirectStatus);
      searchParams.delete('status');
      setSearchParams(searchParams);
    }
  }, [searchParams, toastMessageHandler]);

  return null;
}
